import { type Child } from "~/api/children/types";
import { type NameSearchField } from "~/components/collect/operator/collect-name-filter";
import { getNameInitials } from "~/utils/get-name-initials";

// Reuse getNameInitials ("FL"): first name = first letter, last name = second.
function getSearchInitial(
  name: string,
  searchBy: NameSearchField
): string | undefined {
  const initials = getNameInitials(name);
  return searchBy === "firstName" ? initials?.[0] : initials?.[1];
}

/** Letters with at least one matching student, for fading the rest. */
export function getAvailableInitials(
  students: Child[],
  searchBy: NameSearchField
): Set<string> {
  const initials = new Set<string>();

  for (const student of students) {
    const initial = getSearchInitial(student.name, searchBy);
    if (initial) {
      initials.add(initial);
    }
  }

  return initials;
}

/** Students whose name initial matches `letter`; a null letter filters nothing. */
export function filterByInitial(
  students: Child[],
  searchBy: NameSearchField,
  letter: string | null
): Child[] {
  if (!letter) {
    return students;
  }

  return students.filter(
    (student) => getSearchInitial(student.name, searchBy) === letter
  );
}
